import { generateHTML, generateJSON } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import Image from '@tiptap/extension-image'
import TextAlign from '@tiptap/extension-text-align'

// Email clients drop <style> rules for links, so the button look has to travel inline.
// No font-weight here: the bold mark would read it back on reload; the label carries <strong> instead.
const BUTTON_STYLE =
  'display:inline-block;background-color:#503864;color:#ffffff;padding:12px 28px;border-radius:999px;font-family:Arial,sans-serif;font-size:15px;line-height:20px;text-decoration:none;'

const EmailLink = Link.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      button: {
        default: false,
        parseHTML: (el) => el.getAttribute('data-button') === 'true',
        renderHTML: (attrs) => (attrs.button ? { 'data-button': 'true', style: BUTTON_STYLE } : {}),
      },
    }
  },
})

export const emailExtensions = [
  StarterKit.configure({ link: false, heading: { levels: [1, 2] }, codeBlock: false, code: false }),
  EmailLink.configure({ openOnClick: false, autolink: true, defaultProtocol: 'https' }),
  Image.configure({ HTMLAttributes: { style: 'max-width:100%;height:auto;border-radius:12px;' } }),
  TextAlign.configure({ types: ['heading', 'paragraph'] }),
]

function canonical(html: string) {
  const t = document.createElement('template')
  t.innerHTML = html
  return t.innerHTML.replace(/>\s+</g, '><').trim()
}

/** True when loading the HTML into the editor and saving it back would change nothing. */
export function fitsEditor(html: string) {
  try {
    return canonical(generateHTML(generateJSON(html, emailExtensions), emailExtensions)) === canonical(html)
  } catch {
    return false
  }
}

export function hasMessage(html: string) {
  if (/<img\b/i.test(html)) return true
  return html.replace(/<[^>]+>/g, '').replace(/&nbsp;|&#160;|[\u200b-\u200d\u2060\ufeff]/g, ' ').trim().length > 0
}
